import noUiSlider from 'nouislider';

function init(parent) {
  const slider = parent.querySelector('.numeric-range-select__range');
  noUiSlider.create(slider, {
    cssPrefix: 'range-slider-',
    start: [20, 80],
    connect: true,
    range: {
      min: 0,
      max: 100,
    },
  });
}

export function numericRangeSelect() {
  document.querySelectorAll('.numeric-range-select').forEach((element) => init(element));
}
